module.exports = __webpack_public_path__ + "static/img/mabangtms.a138514c.png";